import CloseIcon from "../../Theme/CustomIcons/Icons/CustomIcons/CloseIcon";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography, Tag } from "antd";
import { css } from "@emotion/css";
import { Badge } from "antd";

import {
  getSupportTicketByIdAction,
  getSupportMesaageByTicketIdAction,
  getAllSupportTicketAction,
} from "../../store/action/admin/supportTicketActions";
import dayjs from "dayjs";
import HelpdeskIcon from "../../Theme/CustomIcons/Icons/CustomIcons/HelpdeskIcon";
import MessageEditIcon from "../../Theme/CustomIcons/Icons/CustomIcons/MessageEditIcon";
import MessageQuestionIcon from "../../Theme/CustomIcons/Icons/Support,Like,Question/MessageQuestionIcon";
import {
  getNotificatonAction,
  markTicketNotificationsRead,
} from "../../store/action/admin/notificationsActions";
import { useUnreadCountsByTickets } from "../../store/selectors/notificationSelectorsByTicketWise";
import { useMemo } from "react";
import { SyncOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const MainMenu = ({
  setVisible,
  setView,
  setIsLoader,
  token,
  SupportButton,
  handleAction,
  setActiveTicketId,
  isLoader,
}) => {
  const getAllSupportTicketList = useSelector(
    (state) => state.getAllSupportTicketList,
  );

  const tokenInfoList = useSelector((state) => state.tokenInfoList);
  const dispatch = useDispatch();

  const isAdmin = tokenInfoList?.info?.type?.toLowerCase() === "admin";

  const goToSupportCenter = () => {
    const baseUrl = process.env.REACT_APP_Frontend_URI;
    window.open(`${baseUrl}/admin/support-listing`, "_blank");
  };

  const handleClose = async () => {
    setVisible(false);
    setView("menu");
  };

  const handleOpenTicket = async (id) => {
    setIsLoader(true);

    try {
      const companyId =
        tokenInfoList?.info?.company?._id ??
        tokenInfoList?.info?.companyId?._id;

      await Promise.all([
        dispatch(getSupportTicketByIdAction(id, token, companyId)),
        dispatch(getSupportMesaageByTicketIdAction(id, token, companyId)),
      ]);

      setView("chat");
    } catch (error) {
      console.error("Error opening ticket:", error);
      setIsLoader(false);
    } finally {
      setIsLoader(false);
    }
  };

  const handleTicketClick = async (ticketId) => {
    setIsLoader(true);
    setActiveTicketId(ticketId);

    const companyId =
      tokenInfoList?.info?.company?._id || tokenInfoList?.info?.companyId?._id;

    if (companyId && token && tokenInfoList?.info?._id) {
      dispatch(
        markTicketNotificationsRead(
          ticketId,
          companyId,
          token,
          tokenInfoList?.info?._id,
        ),
      );

      dispatch(getNotificatonAction(companyId, token));
    }
    handleOpenTicket(ticketId);
  };

  const onRefresh = async () => {
    if (tokenInfoList?.info && token) {
      setIsLoader(true);
      const companyId =
        tokenInfoList?.info?.company?._id ??
        tokenInfoList?.info?.companyId?._id;
      await dispatch(getAllSupportTicketAction(token, companyId));
      dispatch(getNotificatonAction(companyId, token));
      setIsLoader(false);
    }
  };

  const tickets = (getAllSupportTicketList?.info?.data || []).sort((a, b) => {
    const dateA = new Date(a?.lastMessageTime || a?.updatedAt || 0);
    const dateB = new Date(b?.lastMessageTime || b?.updatedAt || 0);

    return dateB - dateA;
  });

  const notifications =
    useSelector((state) => state?.notificationsList)?.notifyInfo || [];
  const unreadCounts = useUnreadCountsByTickets(tickets);
  const allUnreadCounts = useMemo(() => unreadCounts, [notifications, tickets]);

  const GoToSupportCenterButton = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "10px 0px 12px",
      }}>
      <div
        onClick={goToSupportCenter}
        className={css`
          position: relative;
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          color: #ffffff !important;

          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.5px;
          transition: color 0.2s ease;

          /*  Underline pseudo-element */
          &::after {
            content: "";
            position: absolute;
            bottom: -4px;
            left: 0;
            width: 0;
            height: 1px;
            background: #ffbb96;
            transition: width 0.3s ease;
          }

          &:hover {
            color: rgba(255, 255, 255, 0.65);
          }

          /*  Expand underline on hover */
          &:hover::after {
            width: 100%;
          }

          &:hover .support-arrow-icon {
            transform: translate(2px, -2px);
            color: #ffbb96 !important;
          }

          .support-arrow-icon {
            transition: all 0.2s ease;
            color: rgba(255, 255, 255, 0.65);
          }
        `}>
        <span>GO TO SUPPORT CENTER</span>
        <svg
          className="support-arrow-icon"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
      </div>
    </div>
  );

  return (
    <div
      style={{
        background: "rgba(0,0,0,1)",
        height: "100%",
        width: 380,
        display: "flex",
        flexDirection: "column",
      }}>
      {Array.isArray(getAllSupportTicketList?.info?.data) &&
      getAllSupportTicketList?.info?.data.length > 0 ? (
        /* Ticket List State */
        <div
          style={{
            flex: 1,
            padding: "10px 0px",
            marginTop: "0px",
            backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.7) 40%, rgba(0,0,0,1) 100%), url('https://catalyst-app-bucket.s3.ap-south-1.amazonaws.com/support-widget-background1.png')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}>
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 16px 12px",
              flexShrink: 0,
            }}>
            <div style={{ display: "flex" }}>
              <Text
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: 500,
                }}>
                Support Center
              </Text>
              <SyncOutlined
                onClick={onRefresh}
                spin={isLoader}
                style={{
                  color: "white",
                  marginLeft: "10px",
                }}
              />
            </div>
            <CloseIcon
              style={{
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </div>

          {/* Scrollable Ticket List */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              overflowY: "auto",
              height: "420px",
              padding: "10px 10px 0px",
              background: `linear-gradient(to bottom, rgba(82, 79, 77, 0.9) 40%, rgba(0,0,0,1) 100%)`,
              flexShrink: 0,
            }}>
            {getAllSupportTicketList?.info?.data
              ?.filter((t) => t.status === "opened")
              ?.map((ticket) => {
                const unreadCount = allUnreadCounts[ticket._id] || 0;

                return (
                  <div
                    key={ticket._id}
                    onClick={() => handleTicketClick(ticket._id)}
                    style={{
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid #5c5757",
                      borderRadius: "8px",
                      padding: "12px",
                      cursor: "pointer",
                      position: "relative",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}>
                      <div
                        style={{
                          color: "#A8A8A8",
                          fontSize: "10px",
                          textTransform: "uppercase",
                        }}>
                        {ticket.ticketId}
                      </div>
                      {unreadCount > 0 && (
                        <Badge
                          count={unreadCount}
                          style={{
                            backgroundColor: "#f3a27c",
                            color: "black",
                            borderRadius: "50%",
                            minWidth: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                          }}
                        />
                      )}
                    </div>

                    <div
                      style={{
                        color: "white",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}>
                      {ticket.subject}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "8px",
                      }}>
                      <div style={{ color: "#A8A8A8", fontSize: "11px" }}>
                        {dayjs(ticket.createdAt).format(
                          "hh:mm a • DD MMMM, YYYY",
                        )}
                      </div>
                      <Tag
                        color={ticket.status === "open" ? "success" : "default"}
                        style={{
                          margin: 0,
                          fontSize: "10px",
                          background:
                            ticket.status === "opened"
                              ? "rgba(183,235,143,0.1)"
                              : "rgba(168,168,168,0.1)",
                          border: "none",
                          color:
                            ticket.status === "opened" ? "#B7EB8F" : "#A8A8A8",
                        }}>
                        {ticket.status?.toUpperCase()}
                      </Tag>
                    </div>
                  </div>
                );
              })}
            <Text
              style={{
                color: "#CECECE",
                fontSize: "10px",
                fontWeight: "700",
              }}>
              CLOSED
            </Text>
            {tickets
              ?.filter((i) => i?.status === "closed")
              ?.map((ticket) => (
                <div
                  key={ticket._id}
                  onClick={() => handleOpenTicket(ticket?._id)}
                  style={{
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid #5c5757",
                    borderRadius: "8px",
                    padding: "12px",
                    cursor: "pointer",
                    position: "relative",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <div
                      style={{
                        color: "#A8A8A8",
                        fontSize: "10px",
                        textTransform: "uppercase",
                        marginBottom: "4px",
                      }}>
                      {ticket?.ticketId}
                    </div>
                  </div>

                  <div
                    style={{
                      color: "white",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}>
                    {ticket.subject}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "8px",
                    }}>
                    <div style={{ color: "#A8A8A8", fontSize: "11px" }}>
                      {dayjs(ticket.createdAt).format(
                        "hh:mm a • DD MMMM, YYYY",
                      )}
                    </div>
                    <Tag
                      color={ticket.status === "open" ? "success" : "default"}
                      style={{
                        margin: 0,
                        fontSize: "10px",
                        background:
                          ticket.status === "opened"
                            ? "rgb(183, 235, 143,0.1)"
                            : "rgb(168, 168, 168,0.1)",
                        border: "none",
                        color:
                          ticket.status === "opened" ? "#B7EB8F" : "#A8A8A8",
                      }}>
                      {ticket.status?.toUpperCase()}
                    </Tag>
                  </div>
                </div>
              ))}
          </div>

          {/* Bottom Buttons */}
          <div
            style={{
              borderTop: "1px solid #FFFFFF14",
              flexShrink: 0,
              marginTop: "auto",
              padding: "12px 16px 0px",
            }}>
            <Button
              className={css`
                &:hover {
                  background: #ffa56b !important;
                  border: none !important;
                }
              `}
              style={{
                width: "100%",
                background: "#FFBB96",
                height: "40px",
                border: "none",
                borderRadius: "8px",
                color: "black",
                fontWeight: 600,
                fontSize: "12px",
                letterSpacing: "0.5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
              onClick={() => setView("menu2")}>
              CREATE A TICKET
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </Button>

            {isAdmin && <GoToSupportCenterButton />}
          </div>
        </div>
      ) : (
        /* Welcome / Grid State */
        <>
          <div
            style={{
              height: "400px",
              backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.5) 40%, rgba(0,0,0,1) 100%), url('https://catalyst-app-bucket.s3.ap-south-1.amazonaws.com/support-widget-background1.png')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              padding: "24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              <Text
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: 500,
                }}>
                Support Center
              </Text>
              <CloseIcon
                style={{
                  color: "white",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              />
            </div>
            <div>
              <div
                style={{
                  fontSize: "24px",
                  color: "white",
                  fontWeight: 500,
                }}>
                {tokenInfoList?.info &&
                  `Hi ${tokenInfoList?.info?.name?.firstName} 👋`}
              </div>
              <Title
                level={2}
                style={{
                  color: "#d4a373",
                  margin: "8px 0 0 0",
                  fontWeight: 400,
                  fontSize: "32px",
                }}>
                How can we help?
              </Title>
            </div>
          </div>
          <div style={{ padding: "24px 24px 16px", flex: 1 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}>
              <SupportButton
                icon={<HelpdeskIcon size="small" />}
                label="Help & Support"
                onClick={() => handleAction("Help & Support")}
              />
              <SupportButton
                icon={<MessageQuestionIcon size="small" />}
                label="Technical Issue"
                onClick={() => handleAction("Technical Issue")}
              />
              <SupportButton
                icon={<MessageEditIcon size="small" />}
                label="Feature Request"
                onClick={() => handleAction("Feature Request")}
              />
              <SupportButton
                label="Other"
                isSmall={true}
                onClick={() => handleAction("Other")}
              />
            </div>

            {/* Go to Support Center - ADMIN ONLY */}
            {isAdmin && <GoToSupportCenterButton />}
          </div>
        </>
      )}
    </div>
  );
};

export default MainMenu;
